import { useContext } from "react";

import ResearchCommentForm04 from "./ResearchCommentForm04";
import ResearchCommentList04 from "./ResearchCommentList04";
import { AuthContext } from "../../../../context/AuthProvider";

const ResearchComment04 = ({
  board,
  boardItem,
  replyMode,
  setReplyMode,
  className = "",
}) => {
  const { isAuthenticated } = useContext(AuthContext);

  return !!board?.options?.useComment ? (
    <div
      className={`flex flex-col md:gap-10 gap-4 pt-10 border-t border-gray-border ${className}`}
    >
      <ResearchCommentList04
        board={board}
        boardItem={boardItem}
        setReplyMode={setReplyMode}
      />

      <div id="reply-form">
        {isAuthenticated && replyMode ? (
          <ResearchCommentForm04
            board={board}
            boardItem={boardItem}
            setReplyMode={setReplyMode}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  ) : null;
};

export default ResearchComment04;
